const HOSTED_FORM_URL = 'https://checkout.paybyrd.com/#/payment';

export { HOSTED_FORM_URL };
